import { TimeFilterType } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { i18next } from '@frontend/i18n';

export const X_AXIS_TIME_FILTER_OPTIONS = [
  { label: i18next.t('Daily', { ns: 'analytics' }), value: TimeFilterType.DAILY },
  { label: i18next.t('Day of the week', { ns: 'analytics' }), value: TimeFilterType.DAY_OF_WEEK },
  { label: i18next.t('Hour of Day', { ns: 'analytics' }), value: TimeFilterType.HOURLY },
];
